
export const attendance = {
  '1': [
    { id: '1', moduleId: 'Introduction to Web Development', date: '2025-07-14', status: 'present' },
    { id: '2', moduleId: 'Introduction to Web Development', date: '2025-07-15', status: 'present' },
  ],
  '2': [
    { id: '3', moduleId: 'Introduction to Web Development', date: '2025-07-14', status: 'absent' },
  ],
};

export const attendanceData = [
  { id: '1', learner: 'learner1', moduleId: '1', date: '2025-07-25', status: 'present', arrivalTime: '10:00', departureTime: '12:00' },
  { id: '2', learner: 'learner2', moduleId: '1', date: '2025-07-25', status: 'present', arrivalTime: '10:05', departureTime: '12:00' },
  { id: '3', learner: 'learner1', moduleId: '1', date: '2025-07-27', status: 'present', arrivalTime: '14:00', departureTime: '16:00' },
  { id: '4', learner: 'learner2', moduleId: '1', date: '2025-07-27', status: 'present', arrivalTime: '14:00', departureTime: '16:00' },
  { id: '5', learner: 'learner1', moduleId: '2', date: '2025-07-29', status: 'absent', arrivalTime: null, departureTime: null },
  { id: '6', learner: 'learner2', moduleId: '2', date: '2025-07-29', status: 'late', arrivalTime: '14:15', departureTime: '16:00' }
];
